import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimesCircle = props => /*#__PURE__*/_jsx("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 28",
  className: `svg-icon ${props.className || ''}`,
  children: /*#__PURE__*/_jsx("path", {
    d: "M17.953 17.531a1 1 0 0 0-.297-.703L14.828 14l2.828-2.828a.996.996 0 0 0 0-1.422L16.25 8.344c-.187-.187-.453-.297-.719-.297s-.516.109-.703.297L12 11.172 9.172 8.344a.996.996 0 0 0-1.422 0L6.344 9.75c-.187.187-.297.453-.297.719s.109.516.297.703L9.172 14l-2.828 2.828a.996.996 0 0 0 0 1.422l1.406 1.406c.187.187.453.297.719.297s.516-.109.703-.297L12 16.828l2.828 2.828a.996.996 0 0 0 1.422 0l1.406-1.406c.187-.187.297-.453.297-.719M24 14c0 6.625-5.375 12-12 12S0 20.625 0 14 5.375 2 12 2s12 5.375 12 12"
  })
});
const Memo = /*#__PURE__*/memo(SvgTimesCircle);
export default Memo;